import React from "react"
import { ChevronRight, Loader2 } from "lucide-react"
import type { StudentSubject } from "../../Questions/types"
import "./SubjectStep.style.scss"

interface SubjectStepProps {
  subjects: StudentSubject[]
  loading: boolean
  error: string
  onSelect: (subject: StudentSubject) => void
}

const SubjectStep = ({ subjects, loading, error, onSelect }: SubjectStepProps) => (
  <div className="subject-step">
    <h2>Choose a subject to begin</h2>
    {loading && (
      <p className="subject-step__status">
        <Loader2 size={16} className="is-spinning" /> Loading subjects…
      </p>
    )}
    {!loading && error && <p className="subject-step__status is-error">{error}</p>}
    {!loading && !error && subjects.length === 0 && (
      <p className="subject-step__status">No subjects available yet.</p>
    )}
    {!loading && !error && subjects.length > 0 && (
      <div className="subject-step__grid">
        {subjects.map((sub) => (
          <button
            key={sub.id}
            type="button"
            onClick={() => onSelect(sub)}
          >
            <span>{sub.title}</span>
            <ChevronRight size={20} />
          </button>
        ))}
      </div>
    )}
  </div>
)

export default SubjectStep
